import { render, staticRenderFns } from "./RoomPreviewCard.vue?vue&type=template&id=17bc8445"
import script from "./RoomPreviewCard.vue?vue&type=script&lang=js"
export * from "./RoomPreviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports